<template>
    <div>
      <div style="margin: 10px 0">
        <el-input style="width: 200px;" type="text" v-model="name" placeholder="请输入名称" suffix-icon="el-icon-search"></el-input>
        <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button>
        
        <!-- <el-button style="float:right; " type="primary" @click="exp">导出<i class="el-icon-top"></i></el-button>
        <el-upload
          action="http://localhost:9090/user/import" :on-success = 'handelsuccess' style="float:right;margin-left: 10px">
          <el-button style="float:right;" type="primary">导入<i class="el-icon-bottom"></i></el-button>
        </el-upload> -->
        <el-button v-if="user.role !== '用户'" style="float:right; margin-left: 10px" type="danger" @click = "deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
        <el-button v-if="user.role !== '用户'" style="float:right;" type="primary" @click = "handAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <!-- eslint-disable-next-line -->
      <el-table :data="tableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
        <el-table-column v-if="user.role !== '用户'" type="selection" width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="name" label="用户名" min-width="140">
        </el-table-column>
        <el-table-column label="所属公司" min-width="160">
          <template slot-scope="scope">
            {{ getCompanyName(scope.row.companyid) }}
          </template>
        </el-table-column>
        <el-table-column prop="role" label="角色" min-width="120">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.phone || '未填写' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="住址" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.address || '未填写' }}
          </template>
        </el-table-column>
        <el-table-column v-if="user.role !== '用户'" label="操作" width="250" align="center">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope"><!-- scope 拿到数据-->
            <!-- <el-button type="success" @click = "handEdit(scope.row)" style="margin-right: 5px">编辑<i class="el-icon-edit"></i></el-button> -->
            <div style="display: flex;">
              <div style="margin-left: 20px">
                <el-popover 
                  placement="top"
                  width="80"
                  trigger="click">
                  <p>您确定要重置吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="visible=false">取消</el-button>
                    <el-button type="primary" size="mini" @click=handreset(scope.row.id)>确定</el-button>
                  </div>
              <el-button type="success" slot="reference" style="width: 100px; text-align: center;">重置密码</el-button>
              
            </el-popover>
              </div>
              <div style="margin-left: 20px">
                <el-popover 
                  placement="top"
                  width="80"
                  trigger="click">
                  <p>您确定要删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="visible=false">取消</el-button>
                    <el-button type="primary" size="mini" @click=handdele(scope.row.id)>确定</el-button>
                  </div>
                    <el-button type="danger" slot="reference" style="width: 80px;">删除</el-button>
                </el-popover>
              </div>
            </div>
            
            
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-dialog title="用户信息" :visible.sync="dialogFormVisible" width="30%" >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="用户名">
            <!-- 编辑已有用户时不允许修改用户名 -->
            <el-input v-model="form.name" :disabled="!!form.id"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item label="公司" v-if = "user.role === '超级管理员'">
            <el-select v-model="form.companyid" placeholder="请选择公司">
              <el-option v-for="item in options1" 
              :key="item.id"
              :label="item.name"
              :value="item.id"></el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="用户角色" v-if="user.role === '超级管理员'">
            <el-select v-model="form.role" placeholder="用户角色">
              <el-option label="管理员" value= "管理员"></el-option>
              <el-option label="用户" value="用户"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">确定</el-button>
            <el-button @click ='shutDown'>取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
      name: "User",
      data () {
        return{
          tableData: [],
          name: '',
          pageNum: 1,
          pageSize: 10,
          total: 0,
          dialogFormVisible: false,
          form: {},
          multipleSelection: {},
          headerBg: 'headerBg',
          data: {},
          visible: true,
          user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
          comid: null,
          options1:[],
          companies:[]
        }
      },
      mounted () {
        //请求分页查询
        this.getcompanies()
        this.load()
      },
      methods: {
        load () {//点击页码进行get请求
          this.request.get('/api/user/page', {
            params: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              name: this.name
            }
          }).then(res => {
            this.tableData = res.records
            this.total = res.total
          }).catch(error => {
            console.error(error)
          })
        },
        save () { // 新增或更新
          if(this.user.role != "超级管理员"){
            this.form.companyid = this.user.companyid
            // 管理员只能创建普通用户
            this.form.role = "用户"
          }

          // 确保必要的字段被正确设置（防止undefined被传递）
          this.form.isdeleted = 0  // 明确设置为未删除
          this.form.issuspend = 0  // 明确设置为未禁用

          console.log('发送的用户数据:', this.form)

          this.request.post('/api/user/', this.form).then(res => {
            if (res) {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.success('保存失败')
            }
          })
        },
        getcompanies () {
          this.request.get('/api/companies/').then(res => {
            if(res.code === "200"){
              this.companies = res.data; // 保存完整公司信息用于显示
              this.options1 = res.data.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
            }else{
              console.log(res.code, res.data);
            }
          })
        },
        getCompanyName(companyId) {
          if (!companyId) return '未分配';
          const company = this.companies.find(c => c.id === companyId);
          return company ? company.name : '未知公司';
        },
        handAdd () {
          this.dialogFormVisible = true //打开表单
          this.form = {}
        },
        handEdit (row) { //把row里的数据传给表单
          this.form = row
          this.dialogFormVisible = true
        },
        handdele (id) { //通过id删除
          this.request.delete('/api/user/' + id).then(res => {
            if (res.code === "200") {
              
              this.$message.success('删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        handleSelectionChange (val) {
          console.log(val)
          this.multipleSelection = val
        },
        deleteBatch () {
          // eslint-disable-next-line
          let ids = this.multipleSelection.map(val => val.id)
          this.request.delete('/api/user/del/batch' + ids).then(res => {
            if (res) {
              this.$message.success('批量删除成功')
              this.load()
            } else {
              this.$message.success('删除失败')
            }
          })
        },
        shutDown () {
          this.dialogFormVisible = false
        },
        exp () { //导出
          window.open("http://localhost9090/user/export")
        },
        handelsuccess () {
          this.$message.success('文件上传成功')
          this.load()
        },
        handleSizeChange (pageSize) {
          this.pageSize = pageSize
          this.load()
        },
        handleCurrentChange (pageNum) {
          this.pageNum = pageNum
          this.load()
        },
        handreset(id){
          this.request.post("/api/user/" + id + "/reset-password").then(res =>{
            if(res.code == 200){
              this.$message.success('重置密码成功')
              this.load()
            }else {
              this.$message.success('重置密码失败')
            }
          })
        }
      }
    }
    </script>
    
    <style scoped>
    
    </style>
    